const ROUTES = {
  ROOT: '/',
  INDEX: 'index',
  MAINTENANCE: 'maintenance',
  ERROR: '/error',
  LOGIN: '/login',
  NOT_ALLOWED: '/not-allowed',
  AUTHENTICATION: '/authentication',
  VACATIONS_ABSENCES: {
    ROOT: 'vacations-absences',
    EMPLOYEE_CALENDAR: '/employee-calendar/:employeeId?from',
    EMPLOYEE_CALENDAR_MOBILE: '/employee-calendar-mobile/:employeeId?from',
    MY_VACATIONS: '/my-vacations',
    MY_VACATIONS_MOBILE: '/my-vacations-mobile',
    TEAM_CALENDAR: '/team-calendar',
    TEAM_CALENDAR_MOBILE: '/team-calendar-mobile',
    TEAM_REQUESTS: '/team-requests',
    DELEGATE: '/delegations',
    PERIOD_LIST_MOBILE: '/period-list-mobile',
    SCHEDULE_MOBILE: '/schedule-mobile'
  },
  LOANS: {
    ROOT: 'loans',
    CREDITWORTHINESS: '/my-creditworthiness',
    LOANS_CATALOG: '/catalog',
    DETAIL: '/detail/:loanId?panel',
    SIGN_UP: '/sign-up/:loanId?from',
    MY_LOANS: '/my-loans',
    REPAYMENT: '/repayment',
    NEED_A_LOAN: '/need-a-loan',
    NEED_A_LOAN_RESULTS: '/need-a-loan/results',
    WAGE_ADVANCE: '/wage-advance',
    CADASTRAL_REFERENCE: '/cadastral-reference',
    DETAILSADHESION: '/adhesion'
  },
  FOOD_BENEFIT: {
    ROOT: 'food-benefit',
    MY_FOOD_BENEFIT: '/my-food-benefit',
    MANAGER: '/food-benefit-manager',
    DELEGATE: '/delegations',
    WORK_TEAM: '/work-team'
  },
  SOLIDARITY: {
    ROOT: 'solidarity',
    MY_SOLIDARITY: '/my-solidarity',
  },
  SOCIAL_SECURITY: 'social-security',
};

export {
  ROUTES
};



// WEBPACK FOOTER //
// ./client/app/common/domain/routes.js